var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Direction } from '../tooltip.type';
import { ColorHex } from '@axafr-btc-ds/colors';
import { minimumVerticalSpace, animationTiming, messageWidth, transitionDistance, triangleBaseSize, triangleWidth, defaultTriangleOffsetLeft } from '../constants';
import { getSpaceLeft, getSpaceRight } from '../direction-detection';
export var getMessageStyle = function (_a) {
    var direction = _a.direction, isOpen = _a.isOpen, messageShift = _a.messageShift, verticalOffset = _a.verticalOffset, originWidth = _a.originWidth;
    var openVerticalOffset = triangleBaseSize + transitionDistance + minimumVerticalSpace + verticalOffset;
    var baseTransform = "translateX(-50%) translateX(".concat(Math.round(originWidth / 2), "px)");
    var isDownOpenTransform = "translateY(".concat(openVerticalOffset, "px)");
    var isUpOpenTransform = "translateY(-".concat(openVerticalOffset, "px)");
    var messageShiftTransform = "translateX(".concat(messageShift, "px)");
    return {
        width: messageWidth,
        maxWidth: messageWidth,
        transform: direction === Direction.down
            ? "".concat(baseTransform, " ").concat(messageShiftTransform, " ").concat(isOpen ? isDownOpenTransform : '')
            : "".concat(baseTransform, " translateY(-100%) translateY(-").concat(triangleBaseSize / 2, "px) translateY(").concat(transitionDistance * 2, "px) ").concat(messageShiftTransform, " ").concat(isOpen ? isUpOpenTransform : ''),
        opacity: isOpen ? 1 : 0,
        transition: "opacity ".concat(animationTiming, " cubic-bezier(0.88, -0.05, 0, 1.08) 0.1s,\n            transform ").concat(animationTiming, " ease-in-out 0.1s")
    };
};
export var getTriangleStyles = function (_a) {
    var _b, _c;
    var direction = _a.direction, messageShift = _a.messageShift, originBounds = _a.originBounds, containerBounds = _a.containerBounds;
    var cssDirectionProperty = direction === Direction.down ? 'top' : 'bottom';
    var left = defaultTriangleOffsetLeft - messageShift;
    var minimumHorizontalSpace = 20;
    var isVisible = getSpaceLeft({ containerBounds: containerBounds, originBounds: originBounds }) >= minimumHorizontalSpace
        && getSpaceRight({ containerBounds: containerBounds, originBounds: originBounds }) >= minimumHorizontalSpace;
    var sharedStyle = {
        bottom: 'auto',
        content: '',
        left: left,
        position: 'absolute',
        top: 'auto',
        borderWidth: '0 0.8rem 1rem 0.8rem',
        borderStyle: 'solid',
        transform: direction === Direction.up && 'rotate(180deg)',
        display: isVisible ? 'block' : 'none'
    };
    var outerTriangleStyle = __assign(__assign({}, sharedStyle), (_b = { borderColor: "".concat(ColorHex.transparent, " ").concat(ColorHex.transparent, " ").concat(ColorHex.azure) }, _b[cssDirectionProperty] = -triangleBaseSize - triangleWidth, _b));
    var innerTriangleStyle = __assign(__assign({}, sharedStyle), (_c = { borderColor: "".concat(ColorHex.transparent, " ").concat(ColorHex.transparent, " ").concat(ColorHex.ghostwhite) }, _c[cssDirectionProperty] = -triangleBaseSize, _c));
    return { outerTriangleStyle: outerTriangleStyle, innerTriangleStyle: innerTriangleStyle };
};
